/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** SortDirection */
export enum SortDirection {
  Asc = "asc",
  Desc = "desc",
}

/** SectionKind */
export enum SectionKind {
  Recurring = "recurring",
  OneOff = "one_off",
}

/** SearchType */
export enum SearchType {
  Direction = "direction",
  Discipline = "discipline",
  School = "school",
  Trainer = "trainer",
  News = "news",
}

/** CompetitionStatus */
export enum CompetitionStatus {
  Draft = "draft",
  RegistrationOpen = "registration_open",
  RegistrationClosed = "registration_closed",
  Finished = "finished",
  Cancelled = "cancelled",
}

/** CatalogProfileType */
export enum CatalogProfileType {
  School = "school",
  Trainer = "trainer",
}

/** CatalogAttachmentData */
export interface CatalogAttachment {
  id: number;
  title: string | null;
  name: string;
  original_name: string;
  mime: string;
  size: number;
  url: string;
}

/** CatalogContactData */
export interface CatalogContact {
  email: string;
  phone: string;
  address: string;
  site: string | null;
}

/** CatalogQuoteData */
export interface CatalogQuote {
  author_name: string;
  author_position: string | null;
  image_url: string | null;
  text: string;
}

/** DirectionReferenceData */
export interface DirectionRef {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

/** DisciplineReferenceData */
export interface DisciplineRef {
  id: string;
  direction_id: string;
  name: string;
  slug: string;
}

/** IdData */
export interface Id {
  id: string;
}

/** LessonTypeReferenceData */
export interface LessonTypeRef {
  id: string;
  name: string;
  slug: string;
}

/** PageMetaData */
export interface PageMeta {
  page: number;
  per_page: number;
  total: number;
  last_page: number;
}

/** PaginatedResultDataOfPublicCompetitionData */
export interface PaginatedResultDataOfPublicCompetition {
  items: Competition[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicNewsData */
export interface PaginatedResultDataOfPublicNews {
  items: News[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicSchoolData */
export interface PaginatedResultDataOfPublicSchool {
  items: School[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicTrainerData */
export interface PaginatedResultDataOfPublicTrainer {
  items: Trainer[];
  meta: PageMeta;
}

/** PaginatedResultDataOfSearchResult */
export interface PaginatedResultDataOfSearchResult {
  items: SearchResult[];
  meta: PageMeta;
}

/** PaginatedResultDataOfSectionData */
export interface PaginatedResultDataOfSection {
  items: Section[];
  meta: PageMeta;
}

/** PointData */
export interface Point {
  latitude: number;
  longitude: number;
}

/** PublicCompetitionCategoryData */
export interface CompetitionCategory {
  id: string;
  name: string;
  description: string | null;
  max_participants: number;
  sort: number;
}

/** PublicCompetitionData */
export interface Competition {
  id: string;
  title: string;
  slug: string;
  organizer_name: string;
  location_name: string;
  address: string | null;
  description: string | null;
  participants_count: number;
  max_participants: number | null;
  image_url: string | null;
  starts_at: string;
  ends_at: string;
  status: CompetitionStatus;
  region: RegionRef;
  direction: DirectionRef;
  discipline: DisciplineRef | null;
}

/** PublicCompetitionDetailsData */
export interface CompetitionDetails {
  id: string;
  title: string;
  slug: string;
  organizer_name: string;
  competition_scoring_type: string;
  tournament_system: string;
  location_name: string;
  address: string | null;
  description: string | null;
  participants_count: number;
  max_participants: number | null;
  entry_fee: number | null;
  prize_fund: number | null;
  rules_and_regulations: string | null;
  image_url: string | null;
  detail_image_url: string | null;
  starts_at: string;
  ends_at: string;
  status: CompetitionStatus;
  region: RegionRef;
  direction: DirectionRef;
  categories: CompetitionCategory[];
  gallery: CatalogAttachment[];
  documents: CatalogAttachment[];
  discipline: DisciplineRef | null;
}

/** PublicDirectionData */
export interface Direction {
  id: string;
  /**
   * Направления больше не образуют иерархию. Поле всегда содержит `null`.
   * @deprecated
   */
  parent_id: string | null;
  name: string;
  slug: string;
  description: string | null;
  icon: string;
  image_url: string | null;
  logo_url: string | null;
  logo_mobile: string | null;
  transparent_logo_url: string | null;
  schools_count: number;
  trainers_count: number;
  disciplines_count: number;
}

/** PublicDirectionPageData */
export interface DirectionPage {
  direction: Direction;
  disciplines: Discipline[];
  /**
   * Используйте `disciplines`.
   * @deprecated
   */
  subdirections: Discipline[];
  schools: School[];
  trainers: Trainer[];
  competitions: Competition[];
  news: News[];
}

/** PublicDisciplineData */
export interface Discipline {
  id: string;
  direction_id: string;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  schools_count: number;
  trainers_count: number;
}

/** PublicHomePageData */
export interface HomePage {
  schools: School[];
  trainers: Trainer[];
  news: News[];
  competitions: Competition[];
  directions: Direction[];
}

/** PublicNewsData */
export interface News {
  id: string;
  title: string;
  slug: string;
  preview_description: string;
  image_url: string | null;
  published_at: string;
  direction: DirectionRef | null;
  region: RegionRef;
  directions: DirectionRef[];
  source: SourceRef;
  disciplines: DisciplineRef[];
}

/** PublicNewsDetailsData */
export interface NewsDetails {
  id: string;
  title: string;
  slug: string;
  views_count: number;
  preview_description: string;
  description: string;
  image_url: string | null;
  detail_image_url: string | null;
  published_at: string;
  direction: DirectionRef | null;
  region: RegionRef;
  directions: DirectionRef[];
  source: SourceRef;
  similar_news: News[];
  pride_entries: PrideEntry[];
  disciplines: DisciplineRef[];
}

/** PublicPrideEntryData */
export interface PrideEntry {
  id: string;
  name: string;
  achievements: string[];
  description: string | null;
  image_url: string | null;
  direction: DirectionRef;
  discipline: DisciplineRef | null;
}

/** PublicProfileTrainingScheduleDayData */
export interface ProfileTrainingScheduleDay {
  day_of_week: number;
  day_of_week_label: string;
  entries: ProfileTrainingScheduleEntry[];
}

/** PublicProfileTrainingScheduleEntryData */
export interface ProfileTrainingScheduleEntry {
  training_id: string;
  training_title: string;
  training_description: string | null;
  direction: DirectionRef;
  lesson_type: LessonTypeRef;
  location_name: string | null;
  start_time: string;
  end_time: string;
  capacity: number | null;
  price: number | null;
  discipline: DisciplineRef | null;
}

/** PublicReviewData */
export interface Review {
  id: string;
  author_name: string;
  rating: number;
  content: string;
  created_at: string;
}

/** PublicSchoolData */
export interface School {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  students_count: number;
  trainers_count: number;
  image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  disciplines: DisciplineRef[];
}

/** PublicSchoolDetailsData */
export interface SchoolDetails {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  about_text: string | null;
  rating: number | null;
  location: Point | null;
  contact: CatalogContact | null;
  students_count: number;
  trainers_count: number;
  image_url: string | null;
  detail_image_url: string | null;
  quote: CatalogQuote | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  pride_entries: PrideEntry[];
  gallery: CatalogAttachment[];
  about_images: CatalogAttachment[];
  documents: CatalogAttachment[];
  trainers: Trainer[];
  disciplines: DisciplineRef[];
}

/** PublicTrainerData */
export interface Trainer {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  students_count: number;
  schools_count: number;
  image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  disciplines: DisciplineRef[];
  experience: string | null;
  awards: string | null;
}

/** PublicTrainerDetailsData */
export interface TrainerDetails {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  about_text: string | null;
  rating: number | null;
  contact: CatalogContact | null;
  experience: string | null;
  awards: string | null;
  experience_years: number | null;
  educations: string[];
  achievements: string[];
  students_count: number;
  image_url: string | null;
  quote: CatalogQuote | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  pride_entries: PrideEntry[];
  gallery: CatalogAttachment[];
  about_images: CatalogAttachment[];
  files: CatalogAttachment[];
  disciplines: DisciplineRef[];
}

/** RegionReferenceData */
export interface RegionRef {
  id: string;
  name: string;
  full_name: string;
}

/** ScheduleLessonData */
export interface ScheduleLesson {
  section_id: string;
  kind: SectionKind;
  title: string;
  starts_at: string;
  ends_at: string;
  direction: DirectionRef;
  lesson_type: LessonTypeRef;
  location: string;
  capacity: SectionCapacity;
  price: number | null;
  school: SourceRef | null;
  trainers: SourceRef[];
  can_manage: boolean;
}

/** SearchGroupResultData */
export interface SearchGroupResult {
  directions: [];
  disciplines: [];
  schools: [];
  trainers: [];
  news: [];
}

/** SearchResult */
export interface SearchResult {
  type: SearchType;
  id: string;
  title: string;
  content: string | null;
  formattedTitle: string;
  formattedContent: string | null;
}

/** SectionAgeRangeData */
export interface SectionAgeRange {
  minimum: number | null;
  maximum: number | null;
}

/** SectionCapacityData */
export interface SectionCapacity {
  total: number;
  available: number;
}

/** SectionData */
export interface Section {
  id: string;
  kind: SectionKind;
  title: string;
  description: string | null;
  direction: DirectionRef;
  discipline: DisciplineRef | null;
  lesson_type: LessonTypeRef;
  location: string;
  timezone: string;
  age_range: SectionAgeRange;
  capacity: SectionCapacity;
  price: number | null;
  school: SourceRef | null;
  trainers: SourceRef[];
  recurrences: SectionRecurrence[];
  one_off: SectionOneOff | null;
  can_manage: boolean;
  created_at: string;
  updated_at: string;
}

/** SectionOneOffData */
export interface SectionOneOff {
  id: string;
  date: string;
  time: SectionTimeRange;
}

/** SectionRecurrenceData */
export interface SectionRecurrence {
  id: string;
  weekdays: number[];
  interval_weeks: number;
  starts_on: string;
  ends_on: string | null;
  time: SectionTimeRange;
  exceptions: SectionRecurrenceException[];
}

/** SectionRecurrenceExceptionData */
export interface SectionRecurrenceException {
  date: string;
  reason: string | null;
}

/** SectionTimeRangeData */
export interface SectionTimeRange {
  start: string;
  end: string;
}

/** SourceReferenceData */
export interface SourceRef {
  type: CatalogProfileType;
  id: string;
  name: string;
  slug: string;
}

/** StoreCompetitionParticipationRequestRequest */
export interface StoreCompetitionParticipationRequest {
  /** @maxLength 255 */
  participant_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @format date-time */
  birth_date: string;
  /** @format uuid */
  competition_category_id?: string | null;
  /** @maxLength 255 */
  team_name?: string | null;
  /** @maxLength 5000 */
  additional_information?: string | null;
}

/** StoreFeedbackRequest */
export interface StoreFeedback {
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 5000 */
  message?: string | null;
}

/** StoreReviewRequest */
export interface StoreReview {
  /** @maxLength 255 */
  author_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /**
   * @min 1
   * @max 5
   */
  rating: number;
  /** @maxLength 5000 */
  content: string;
}

/** StoreSchoolCreationRequestRequest */
export interface StoreSchoolCreationRequest {
  /** @maxLength 255 */
  name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 1000 */
  address: string;
  /** @maxLength 255 */
  site?: string | null;
  /** @format uuid */
  region_id: string;
  description: string;
  direction_ids?: string[] | null;
  discipline_ids?: string[] | null;
  /** @minItems 1 */
  license_id: string[];
  /** @minItems 1 */
  founding_document_id: string[];
  /** @minItems 1 */
  registration_certificate_id: string[];
  /** @minItems 1 */
  facility_photo_id: string[];
}

/** StoreTrainerCreationRequestRequest */
export interface StoreTrainerCreationRequest {
  /** @maxLength 255 */
  name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 255 */
  site?: string | null;
  /** @format uuid */
  region_id: string;
  /** @format uuid */
  school_id?: string | null;
  description: string;
  /** @min 1 */
  experience_years: number;
  educations: string[];
  achievements: string[];
  /** @minItems 1 */
  direction_ids: string[];
  discipline_ids?: string[] | null;
  /** @minItems 1 */
  license_id: string[];
}

/** StoreTrainingSignupRequestRequest */
export interface StoreTrainingSignupRequest {
  /** @maxLength 255 */
  visitor_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 2000 */
  message?: string | null;
}

/** TemporaryAttachmentData */
export interface TemporaryAttachment {
  id: number;
  group_key: string;
  name: string;
  original_name: string;
  mime: string;
  size: number;
  url: string;
}

/** UploadTemporaryAttachmentRequest */
export interface UploadTemporaryAttachmentRequest {
  /**
   * Maximum file size: 10240 kilobytes.
   * @format binary
   */
  file: File;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://sport-portal.local/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title SportPortal
 * @version 16.0.0
 * @baseUrl http://sport-portal.local/api
 * @contact Ruslan Shikhmagomedov <shahruslan.m@gmail.com>
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  public = {
    /**
     * No description
     *
     * @tags CompetitionParticipationRequests
     * @name CompetitionParticipationRequestsStore
     * @summary Отправить заявку на участие в соревновании
     * @request POST:/public/v1/competitions/{competition}/participation-requests
     */
    competitionParticipationRequestsStore: (
      competition: string,
      data: StoreCompetitionParticipationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/competitions/${competition}/participation-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Competitions
     * @name Competitions
     * @summary Получить список соревнований
     * @request GET:/public/v1/competitions
     */
    competitions: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        discipline_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicCompetition,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/competitions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Competitions
     * @name CompetitionsDetail
     * @summary Получить детальную информацию о соревновании
     * @request GET:/public/v1/competitions/{competition}
     */
    "competitions.detail": (competition: string, params: RequestParams = {}) =>
      this.request<
        CompetitionDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/competitions/${competition}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreationRequests
     * @name CreationRequestsStoreSchool
     * @summary Создать заявку на добавление школы
     * @request POST:/public/v1/schools/register
     */
    creationRequestsStoreSchool: (
      data: StoreSchoolCreationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/schools/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreationRequests
     * @name CreationRequestsStoreTrainer
     * @summary Создать заявку на добавление тренера
     * @request POST:/public/v1/trainers/register
     */
    creationRequestsStoreTrainer: (
      data: StoreTrainerCreationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/trainers/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Directions
     * @name Directions
     * @summary Получить список направлений
     * @request GET:/public/v1/directions
     */
    directions: (
      query?: {
        /**
         * @minLength 2
         * @maxLength 50
         */
        q?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Direction[],
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/directions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description use /v2/directions/{direction}/disciplines
     *
     * @tags Directions
     * @name Subdirections
     * @summary Получить список поднаправлений
     * @request GET:/public/v1/directions/{direction}/subdirections
     * @deprecated
     */
    subdirections: (direction: string, params: RequestParams = {}) =>
      this.request<
        Discipline[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/directions/${direction}/subdirections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Directions
     * @name SchoolDirections
     * @summary Получить список направлений школы
     * @request GET:/public/v1/schools/{school}/directions
     */
    schoolDirections: (
      school: string,
      query?: {
        /**
         * @minLength 2
         * @maxLength 50
         */
        q?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Direction[],
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/directions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Directions
     * @name TrainerDirections
     * @summary Получить список направлений тренера
     * @request GET:/public/v1/trainers/{trainer}/directions
     */
    trainerDirections: (
      trainer: string,
      query?: {
        /**
         * @minLength 2
         * @maxLength 50
         */
        q?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Direction[],
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/directions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Disciplines
     * @name Disciplines
     * @summary Получить список дисциплин
     * @request GET:/public/v2/directions/{direction}/disciplines
     */
    disciplines: (direction: string, params: RequestParams = {}) =>
      this.request<
        Discipline[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v2/directions/${direction}/disciplines`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feedback
     * @name FeedbackStore
     * @summary Отправить обращение администрации
     * @request POST:/public/v1/feedback
     */
    feedbackStore: (data: StoreFeedback, params: RequestParams = {}) =>
      this.request<
        Id,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/feedback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LessonTypes
     * @name LessonTypes
     * @summary Получить список типов занятий
     * @request GET:/public/v1/lesson-types
     */
    lessonTypes: (params: RequestParams = {}) =>
      this.request<
        LessonTypeRef[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/lesson-types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name News
     * @summary Получить список новостей
     * @request GET:/public/v1/news
     */
    news: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /**
         * Deprecated. Use direction_ids instead.
         * @deprecated
         * @format uuid
         */
        direction_id?: string | null;
        /** @format uuid */
        "direction_ids[]"?: string[];
        /**
         * Deprecated. Use discipline_ids instead.
         * @deprecated
         * @format uuid
         */
        discipline_id?: string | null;
        /** @format uuid */
        "discipline_ids[]"?: string[];
        /** @format uuid */
        school_id?: string | null;
        /** @format uuid */
        trainer_id?: string | null;
        /**
         * @minLength 3
         * @maxLength 255
         */
        q?: string | null;
        sort_by?: "published_at" | "title";
        sort_direction?: SortDirection | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicNews,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/news`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsDetail
     * @summary Получить детальную информацию о новости
     * @request GET:/public/v1/news/{news}
     */
    "news.detail": (news: string, params: RequestParams = {}) =>
      this.request<
        NewsDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/news/${news}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Home
     * @summary Получить данные для главной страницы
     * @request GET:/public/v1/pages/home
     */
    home: (
      query: {
        /** @format uuid */
        region_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        HomePage,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/pages/home`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Direction
     * @summary Получить данные для страницы направления
     * @request GET:/public/v1/pages/direction/{direction}
     */
    direction: (
      direction: string,
      query: {
        /** @format uuid */
        region_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        DirectionPage,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/pages/direction/${direction}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrideEntries
     * @name SchoolPrideEntries
     * @summary Получить раздел «Наша гордость» школы
     * @request GET:/public/v1/schools/{school}/pride-entries
     */
    schoolPrideEntries: (school: string, params: RequestParams = {}) =>
      this.request<
        PrideEntry[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/pride-entries`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrideEntries
     * @name TrainerPrideEntries
     * @summary Получить раздел «Наша гордость» тренера
     * @request GET:/public/v1/trainers/{trainer}/pride-entries
     */
    trainerPrideEntries: (trainer: string, params: RequestParams = {}) =>
      this.request<
        PrideEntry[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/pride-entries`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicAttachments
     * @name AttachmentStore
     * @request POST:/public/v1/attachments/upload
     */
    attachmentStore: (
      data: UploadTemporaryAttachmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TemporaryAttachment,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/attachments/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Regions
     * @name Regions
     * @summary Получить список регионов
     * @request GET:/public/v1/regions
     */
    regions: (
      query?: {
        /** @maxLength 50 */
        q?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RegionRef[],
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/regions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name SchoolReviews
     * @summary Получить отзывы школы
     * @request GET:/public/v1/schools/{school}/reviews
     */
    schoolReviews: (school: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreSchoolReview
     * @summary Оставить отзыв школе
     * @request POST:/public/v1/schools/{school}/reviews
     */
    storeSchoolReview: (
      school: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name TrainerReviews
     * @summary Получить отзывы тренера
     * @request GET:/public/v1/trainers/{trainer}/reviews
     */
    trainerReviews: (trainer: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreTrainerReview
     * @summary Оставить отзыв тренеру
     * @request POST:/public/v1/trainers/{trainer}/reviews
     */
    storeTrainerReview: (
      trainer: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name CompetitionReviews
     * @summary Получить отзывы соревнования
     * @request GET:/public/v1/competitions/{competition}/reviews
     */
    competitionReviews: (competition: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/competitions/${competition}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreCompetitionReview
     * @summary Оставить отзыв соревнованию
     * @request POST:/public/v1/competitions/{competition}/reviews
     */
    storeCompetitionReview: (
      competition: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/competitions/${competition}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Schools
     * @name Schools
     * @summary Получить список школ
     * @request GET:/public/v1/schools
     */
    schools: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /**
         * @minLength 2
         * @maxLength 50
         */
        q?: string | null;
        /** @format uuid */
        region_id: string;
        /**
         * Deprecated. Use direction_ids instead.
         * @deprecated
         * @format uuid
         */
        direction_id?: string | null;
        /** @format uuid */
        "direction_ids[]"?: string[];
        /**
         * Deprecated. Use discipline_ids instead.
         * @deprecated
         * @format uuid
         */
        discipline_id?: string | null;
        /** @format uuid */
        "discipline_ids[]"?: string[];
        /** @format uuid */
        trainer_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
        is_top?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicSchool,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/schools`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Schools
     * @name SchoolsDetail
     * @summary Получить детальную информацию о школе
     * @request GET:/public/v1/schools/{school}
     */
    "schools.detail": (school: string, params: RequestParams = {}) =>
      this.request<
        SchoolDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name Search
     * @summary Получить результаты поиска по запросу
     * @request GET:/public/v1/search
     */
    search: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /**
         * @minLength 3
         * @maxLength 250
         */
        q: string;
        type?: SearchType | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfSearchResult,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name GroupSearch
     * @summary Получить сгруппированные результаты поиска
     * @request GET:/public/v1/search/group
     */
    groupSearch: (
      query: {
        /**
         * @minLength 3
         * @maxLength 250
         */
        q: string;
        /** @format uuid */
        region_id: string;
        /**
         * Deprecated. Use direction_ids instead.
         * @deprecated
         * @format uuid
         */
        direction_id?: string | null;
        /** @format uuid */
        "direction_ids[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SearchGroupResult,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/search/group`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращаются только актуальные секции: с неоконченным повторением или с разовым занятием не раньше сегодняшнего дня.
     *
     * @tags Sections
     * @name SchoolSections
     * @summary Получить секции и разовые занятия школы
     * @request GET:/public/v1/schools/{school}/sections
     */
    schoolSections: (
      school: string,
      query?: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        kind?: SectionKind | null;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        discipline_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfSection,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/sections`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает отдельные занятия с учётом повторений и пропущенных дат, по возрастанию начала.
     *
     * @tags Sections
     * @name SchoolSectionsSchedule
     * @summary Получить расписание занятий школы за период
     * @request GET:/public/v1/schools/{school}/sections/schedule
     */
    schoolSectionsSchedule: (
      school: string,
      query: {
        /** @format date */
        from: string;
        /** @format date */
        to: string;
        kind?: SectionKind | null;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        discipline_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ScheduleLesson[],
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/sections/schedule`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращаются секции, которые тренер ведёт, в том числе секции школы.
     *
     * @tags Sections
     * @name TrainerSections
     * @summary Получить секции и разовые занятия тренера
     * @request GET:/public/v1/trainers/{trainer}/sections
     */
    trainerSections: (
      trainer: string,
      query?: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        kind?: SectionKind | null;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        discipline_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfSection,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/sections`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sections
     * @name TrainerSectionsSchedule
     * @summary Получить расписание занятий тренера за период
     * @request GET:/public/v1/trainers/{trainer}/sections/schedule
     */
    trainerSectionsSchedule: (
      trainer: string,
      query: {
        /** @format date */
        from: string;
        /** @format date */
        to: string;
        kind?: SectionKind | null;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        discipline_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ScheduleLesson[],
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/sections/schedule`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainers
     * @name Trainers
     * @summary Получить список тренеров
     * @request GET:/public/v1/trainers
     */
    trainers: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /**
         * @minLength 2
         * @maxLength 50
         */
        q?: string | null;
        /** @format uuid */
        region_id: string;
        /**
         * Deprecated. Use direction_ids instead.
         * @deprecated
         * @format uuid
         */
        direction_id?: string | null;
        /** @format uuid */
        "direction_ids[]"?: string[];
        /**
         * Deprecated. Use discipline_ids instead.
         * @deprecated
         * @format uuid
         */
        discipline_id?: string | null;
        /** @format uuid */
        "discipline_ids[]"?: string[];
        /** @format uuid */
        lesson_type_id?: string | null;
        is_top?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicTrainer,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/trainers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainers
     * @name TrainersDetail
     * @summary Получить детальную информацию о тренере
     * @request GET:/public/v1/trainers/{trainer}
     */
    "trainers.detail": (trainer: string, params: RequestParams = {}) =>
      this.request<
        TrainerDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Строится из повторяющихся секций школы; разовые занятия сюда не входят. use /v1/schools/{school}/sections/schedule
     *
     * @tags TrainingSchedules
     * @name SchoolSchedule
     * @summary Получить недельное расписание школы
     * @request GET:/public/v1/schools/{school}/schedule
     * @deprecated
     */
    schoolSchedule: (school: string, params: RequestParams = {}) =>
      this.request<
        ProfileTrainingScheduleDay[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/schedule`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Строится из повторяющихся секций, которые ведёт тренер; разовые занятия сюда не входят. use /v1/trainers/{trainer}/sections/schedule
     *
     * @tags TrainingSchedules
     * @name TrainerSchedule
     * @summary Получить недельное расписание тренера
     * @request GET:/public/v1/trainers/{trainer}/schedule
     * @deprecated
     */
    trainerSchedule: (trainer: string, params: RequestParams = {}) =>
      this.request<
        ProfileTrainingScheduleDay[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/schedule`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSignupRequests
     * @name TrainingSignupRequestsStoreSchool
     * @summary Отправить заявку на запись на занятие в школу
     * @request POST:/public/v1/schools/{school}/training-requests
     */
    trainingSignupRequestsStoreSchool: (
      school: string,
      data: StoreTrainingSignupRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/training-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSignupRequests
     * @name TrainingSignupRequestsStoreTrainer
     * @summary Отправить заявку на запись на занятие к тренеру
     * @request POST:/public/v1/trainers/{trainer}/training-requests
     */
    trainingSignupRequestsStoreTrainer: (
      trainer: string,
      data: StoreTrainingSignupRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        Id,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/training-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
